export const STORAGE_KEYS = {
  TOKEN: "gip-amc-data-token",
  SHOW_LOADING: "show_loading",
};

export const MAIN_FONT_FAMILY = "Roboto Slab";

export const ADMIN_PANEL_EMAIL = "admin@gmail.com"
export const ADMIN_PANEL_PASSWORD = "!Password123456"
